import React from "react";
import {RadioButtonFormGroup as PatronRadioButtonFormGroup} from "@unibuddy/patron";

export const RadioButtonFormGroup = (props) => {
    return <PatronRadioButtonFormGroup {...props} />;
};
